<si-form-item [label]="label() | translate">
    <ng-template #helpContent>
        <div
            class="kpi-help-content [&_h3]:mb-3 [&_h3]:block [&_h3]:text-lg [&_h3]:font-semibold [&_h4]:mb-2 [&_h4]:mt-4 [&_h4]:block [&_h4]:font-semibold [&_p]:mb-3 [&_ul]:mb-3 [&_ul]:list-disc [&_ul]:ps-4"
            [innerHTML]="helpText() | translate"
        ></div>
    </ng-template>

    @if (helpTitle() && helpText()) {
        <tran-help si-help-button mode="dialog" dialogClass="modal-lg" [title]="helpTitle()" [content]="helpContent" />
    }

    @if (readonly()) {
        @if (rows().length > 0) {
            <div class="overflow-x-auto rounded-md border border-[var(--element-ui-5)]">
                <table class="table table-hover w-full text-left text-sm">
                    <thead>
                        <tr>
                            <th class="px-4 py-3 font-medium" scope="col">
                                {{ 'components.kpi-selector.kpi' | translate }}
                            </th>
                            <th class="px-4 py-3 font-medium" scope="col">
                                {{ 'components.kpi-selector.start-value' | translate }}
                            </th>
                            <th class="px-4 py-3 font-medium" scope="col">
                                {{ 'components.kpi-selector.target-value' | translate }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of rows(); track row.id) {
                            <tr class="border-b border-[var(--element-ui-6)] last:border-b-0">
                                <td class="px-4 py-3">
                                    {{ row.kpiDefinitionId ? ('kpis.' + row.name | translate) : row.name }}
                                </td>
                                <td class="px-4 py-3">{{ row.startValueLabel }}</td>
                                <td class="px-4 py-3">{{ row.targetValueLabel }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        } @else {
            <div class="py-3 text-sm text-[var(--element-ui-2)]">
                {{ 'components.kpi-selector.no-kpis' | translate }}
            </div>
        }
    } @else {
        <tran-form-array
            [control]="control()"
            [createControl]="createControl"
            addLabel="components.kpi-selector.add-kpi"
            removeLabel="components.kpi-selector.remove-kpi"
            [minItems]="0"
        >
            <ng-template let-kpiForm>
                <tran-kpi-selector
                    [form]="kpiForm"
                    [kpis]="optionsKpis()"
                    [units]="units()"
                    [submitted]="submitted()"
                    [readonly]="readonly()"
                />
            </ng-template>
        </tran-form-array>
    }
</si-form-item>
